import * as React from 'react'
import { useHistory, Redirect, useLocation } from 'react-router-dom'
import * as Domain from '../../../core/domain'
import { ErrorStatus } from '../../../constants/error-status'
import styles from './ApiErrorAlert.module.css'
import ScreenEmbeddedErrorAlert from './ScreenEmbeddedErrorAlert'
import ModalErrorAlert from './ModalErrorAlert'
import RedirectModal from '../RedirectModal'

const { liff } = window

interface Props {
  error: Domain.RecoverableError | Domain.ApiErrorResponse.Entity | null
  actions: {
    clearError: () => void
  }
}

function isRecoverableError(target: Domain.RecoverableError | Domain.ApiErrorResponse.Entity): target is Domain.RecoverableError {
  return (target as Domain.RecoverableError).label !== undefined
}

export default function ApiErrorAlert(props: Props) {
  const {
    error,
    actions: { clearError },
  } = props

  const history = useHistory()
  const search = new URLSearchParams(useLocation().search)

  const closeModal = React.useCallback(() => {
    clearError()
  }, [clearError])

  React.useEffect(() => {
    const unlisten = history.listen(() => {
      if (error) {
        clearError()
      }
    })
    return () => {
      unlisten()
    }
  }, [history, clearError, error])

  if (error == null) {
    return null
  }
  if (isRecoverableError(error)) {
    return (
      <div className={styles.container}>
        <ScreenEmbeddedErrorAlert error={error} />
      </div>
    )
  }
  const navigateToSelectCard = () => {
    history.push({pathname: '/select-card'})
  }
  const backToEventList = () => {
    if (search.get('back')) {
      history.goBack()
    } else {
      liff.closeWindow()
    }
  }
  switch (error.errorCode) {
    case ErrorStatus.MAINTENANCE_ERROR_STATUS:
      return <Redirect to='/mantainance' />
    case ErrorStatus.CARD_REQUIRED_ERROR_STATUS:
      return <RedirectModal redirectUrl={navigateToSelectCard} message={error.errorMessage}/>
    case ErrorStatus.ENTRY_ENDED_EVENT_ERROR_STATUS:
    case ErrorStatus.ENTRY_DELETED_EVENT_ERROR_STATUS:
      return <RedirectModal redirectUrl={backToEventList} message={error.errorMessage}/>
    default:
      return (
        <div className={styles.container}>
          <ModalErrorAlert error={error} onPress={closeModal} />
        </div>
      )
  }
}
